import { CommentWithCreator, ThreadedComment } from '../../Types/comment';

/**
 * Transforms a flat list of comments into a threaded comment tree.
 */
export const buildThreadedComments = (comments: CommentWithCreator[]): ThreadedComment[] => {
  const map = new Map<string, ThreadedComment>();
  const roots: ThreadedComment[] = [];

  comments.forEach((comment) => {
    map.set(comment.id, { ...comment, replies: [] });
  });

  // Build the tree structure
  map.forEach((comment) => {
    if (comment.parentId && map.has(comment.parentId)) {
      map.get(comment.parentId)?.replies.push(comment);
    } else {
      roots.push(comment);
    }
  });

  return roots;
};
